// Ship-by date on the product page [52]: N business days after today, weekends
// skipped, computed in the shopper's browser so cached pages never show a stale date.
// A pre-order variant (data-preorder, set by personalization.js) shows its estimated
// ship date instead (data-ships-on, YYYY-MM-DD from the Pre-order ship date metafield),
// and nothing when that date is missing.

export function shipByDate(start, businessDays) {
  const date = new Date(start.getFullYear(), start.getMonth(), start.getDate());
  let remaining = Math.max(0, Math.floor(businessDays));
  while (remaining > 0) {
    date.setDate(date.getDate() + 1);
    const day = date.getDay();
    if (day !== 0 && day !== 6) remaining -= 1;
  }
  return date;
}

// A calendar date (YYYY-MM-DD) as a local date, or null when it is not a real date.
export function parseShipDate(value) {
  const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(typeof value === 'string' ? value : '');
  if (!match) return null;
  const [year, month, day] = match.slice(1).map(Number), date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
}

export const PREORDER_SHIP_LABEL = 'Pre-order · estimated to ship by';

const ShipBy = typeof HTMLElement === 'undefined' ? null : class extends HTMLElement {
  static get observedAttributes() { return ['data-preorder', 'data-ships-on']; }
  connectedCallback() { this.render(); }
  attributeChangedCallback() { if (this.isConnected) this.render(); }
  render() {
    const target = this.querySelector('[data-ship-date]');
    if (!target) return;
    const preorder = this.hasAttribute('data-preorder'), label = this.querySelector('[data-ship-label]');
    if (label) label.textContent = preorder ? PREORDER_SHIP_LABEL : 'Ships by';
    const days = Number(this.dataset.businessDays);
    const date = preorder ? parseShipDate(this.dataset.shipsOn) : Number.isFinite(days) && days >= 1 ? shipByDate(new Date(), days) : null;
    if (!date) { this.hidden = true; return; }
    target.textContent = date.toLocaleDateString(document.documentElement.lang || undefined, { month: 'short', day: 'numeric' });
    this.hidden = false;
  }
};

if (ShipBy && !customElements.get('fl-ship-by')) customElements.define('fl-ship-by', ShipBy);
